import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import FontIcon from 'react-toolbox/lib/font_icon'
import { Flex, Box } from 'reflexbox'

import StatusColorHoc from './StatusColorHoc'
import TimelineSubSection from './TimelineSubSection'
import TimelineDivider from './TimelineDivider'
import TimelineSectionHeader from './TimelineSectionHeader'
import TimelineDetails from './TimelineDetails'
import TimelineState from './TimelineState'

import styles from './styles.scss'

const isEven = (x) => (x & 1) ? false : true

const TimelineSection = (props) => {
  let subsections = null
  let {
    sectionNumber,
    history,
    title
  } = props

  let header =  StatusColorHoc({...history[0], title, key: 'headerTitle'}, TimelineSectionHeader )

  let headerDivider = (
    <div key='headerDivider' styleName='sectionDivider'>
      {StatusColorHoc({...history[0]}, TimelineDivider)}
    </div>
  )

  let headerComponents = [
    header,
    headerDivider
  ]

  subsections = history.reduce(
    (final, value, index) => {
      let isRight = isEven(index + sectionNumber)
      let detailComponent = TimelineDetails
      let stateComponent = TimelineState

      let subsection = (
        <TimelineSubSection
          key={index}
          name={value.name}
          comment={value.comment}
          action={value.action}
          date={value.date}
          state={value.state}
          leftItem={isRight ? stateComponent : detailComponent}
          rightItem={isRight ? detailComponent: stateComponent}
        />
      )

      return [
        ...final,
        subsection
      ]
    }
  , headerComponents)

  return (
    <Flex auto column align='center' justify='flex-start'>
      { subsections }
    </Flex>
  )
}

TimelineSection.propTypes = {
  history: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  sectionNumber: PropTypes.number.isRequired,
}

export default CSSModules(TimelineSection, styles)
